import { msg } from "../locales/translate";
import { GD } from "../GD";

export interface ITransaction {
	uid: number;
	reference_id: number;
	account_uid: string;
	direction: "expense" | "income"; // Assuming "expense" or "income" are the only possible values
	amount: number;
	balance: number;
	party_uid: string;
	user_uid: string;
	created_at: string; // ISO 8601 date string
	currency: string;
	type_id: number;
	description: string;
	status: "pending" | "completed" | "failed" | "canceled" | "created"; // Assumed possible values
	hash: string;
	partition: number;
	project_id: number;
	currency_id: number;
	meta: any | null; // 'meta' can be any or null
	country: string | null;
	ip: string | null;
	date: number; // Format of date seems like a number (e.g., YYYYMMDDHH)
	party_account_uid: string;
}

export interface ITransactionLog {

}

export interface ITransactions { }

export class Transactions {

	constructor() {
		GD.REQ_TRANSACTIONS_BY_ACCOUNT.listener = async req => {
			const response = await GD.REQ_API.request({ method: "transactions/get", data: { accountUID: req.uid } })
			return response;
		}

		GD.REQ_TRANSACTION_BY_UID.listener = async req => {
			const response = await GD.REQ_API.request({ method: "transactions/info", data: { uid: req } })
			return response;
		}

		GD.REQ_TRANSACTION_LOG.listener = async req => {
			const response = await GD.REQ_API.request({ method: "transactions/log", data: { reference_id: req.referenceID } })
			return response;
		}

		GD.REQ_TRANSACTIONS.listener = async req => {
			const project = await GD.REQ_CURRENT_PROJECT.request();
			if (!project) {
				return { error: { code: 1, message: msg("noProjectSelected") } };
			}
			const response = await GD.REQ_API.request({
				method: "transactions/get", data:
				{
					filter: req,

				}
			})
			return response;
		}
	}

}

